<template>
  <component :is="icon" class="brand-icon" />
</template>

<script>
import { defineAsyncComponent } from 'vue'

const ICONS = {
  facebook: defineAsyncComponent(() => import('@/assets/img/brands/facebook.svg?inline')),
  google: defineAsyncComponent(() => import('@/assets/img/brands/google.svg?inline')),
  apple: defineAsyncComponent(() => import('@/assets/img/brands/apple.svg?inline')),
}

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    icon() {
      return ICONS[this.name]
    },
  },
}
</script>

<style lang="scss" scoped>
.brand-icon {
  width: 1em;
  height: 1em;
}
</style>
